import React from "react";
import NewFeatured from "../featured/NewFeatured";
import "./NewBanner.css";

function NewBanner() {
  return (
    <div className="new-banner">
    <h1 className="penn-text">
      Powered By <span>Penn</span> Microfinance Bank
    </h1>
  
    <div className="banner-contents">
      <img
        src="/assets/Ayo and thamespice 1.webp"
        alt="Banking visual"
        className="new-banner-img1"
      />
  
      <div className="new-banner-text">
        <h1>
          Building the future of <span>retail banking</span> for you
        </h1>
        {/* <img
          src="https://res.cloudinary.com/teb/image/upload/v1671004943/Handdrawn_vector_fvblaz.png"
          alt="decorative underline"
        /> */}
        <p>
          Experience simpler and more personalised banking for you and your business.
        </p>
        <a href="#download-page">Get our app</a>
        <div className="sec-box">
          <img src="/assets/CBN.png" alt="CBN logo" className="cbn-logo" />
          <img src="/assets/sec (2).png" alt="SEC logo" className="cbn-logo" />
        </div>
      </div>
    </div>
  
    <NewFeatured />
    <img src="/assets/Hex.png" alt="decorative hex" className="banner-hexagon" />
  </div>
  
  );
}

export default NewBanner;
